/** @format */

import { useState } from "react";
import { GoSearch } from "react-icons/go";

export const Search = ({
  placeholder,
  getSearchValue,
  icon = true,
  showBtn = false,
  label,
  hideModal,
  stateName,
}) => {
  const [searchValue, setSearch] = useState();
  const handleChange = () => {
    setSearch("");
    getSearchValue(searchValue, label, stateName);
    hideModal();
  };

  return (
    <div className='search__box ' id='search-box'>
      <input
        value={searchValue}
        type='search'
        placeholder={placeholder}
        className='search__box-input input__field '
        onChange={(event) => setSearch(event.target.value)}
      />
      {showBtn && <button onClick={handleChange}>بحث</button>}

      {icon && (
        <GoSearch className='search__box__icon search__box__icon--magnifier' />
      )}
    </div>
  );
};
